import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Loader from "_shared/_views/loading/loader";

const LoadStateContainer = styled(Box)(() => ({
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "center",
  padding: 16,
}));

type AdministrationPermissionsLoadStateProps = {
  error: string | null;
  onRetry: () => void;
};

/**
 * Keeps a failed authorization lookup actionable instead of leaving the
 * administration page on an indefinite loading indicator.
 */
export default function AdministrationPermissionsLoadState({
  error,
  onRetry,
}: Readonly<AdministrationPermissionsLoadStateProps>) {
  if (!error) {
    return (
      <LoadStateContainer>
        <Loader fontSize="20px" text="Loading permissions" />
      </LoadStateContainer>
    );
  }

  return (
    <LoadStateContainer>
      <Alert
        action={
          <Button color="inherit" onClick={onRetry} size="small">
            Retry
          </Button>
        }
        severity="error"
      >
        Unable to load your access permissions. {error}
      </Alert>
    </LoadStateContainer>
  );
}
